/**
 * תבניות למסמכים משפטיים — יש להתאים לעורך דין לפני השקה גלובלית.
 * כתובות ציבוריות: /legal/privacy , /legal/terms (מפנים מ־/privacy ו־/terms)
 */
import { getSupportEmail } from "../supportConfig";

export const SUPPORT_EMAIL = getSupportEmail();

export const LEGAL_COPY = {
  privacy: {
    he: {
      title: "מדיניות פרטיות",
      updated: "עודכן לאחרונה: מרץ 2026 (טיוטה)",
      attorney:
        "מסמך זה הוא תבנית טכנית לשימושכם. טרם שימוש מסחרי או לפני איסוף נתונים באיחוד האירופי או בארצות הברית יש לעבור אצל עורך דין ולהתאים את הנוסח למדיניות האיסוף בפועל.",
      sections: [
        {
          h: "מי אנחנו",
          p: [
            "InnerVoice / Temple of Light (“השירות”) מופעל דרך האתר והאפליקציה. לשאלות פרטיות ניתן לפנות לכתובת: " + SUPPORT_EMAIL + ".",
          ],
        },
        {
          h: "אילו נתונים עלולים להיאסף",
          p: [
            "פרטי חשבון (למשל דוא״ל) בעת הרישום לשירות או הכניסה אליו.",
            "תוכן שבחרתם לשמור במסע — למשל רשומות ביומן או תשובות לשאלונים — בהתאם לאופן השימוש שלכם.",
            "נתוני שימוש טכניים (למשל לוגים, כתובת IP, סוג דפדפן או מכשיר) לצורכי אבטחה ותפעול.",
            "אם מופעלת קריינות דרך השרת, טקסט שמסופק לייצור אודיו עשוי לעבור לספק חיצוני (למשל ElevenLabs) לפי הגדרות השרת. קריינות מקומית בדפדפן עשויה שלא לעבור לשרת.",
          ],
        },
        {
          h: "מטרות ולגיטימציה",
          p: [
            "מתן השירות, אימות משתמשים, תמיכה, שיפור איכות ואבטחה.",
            "במקרים רלוונטיים — עמידה בדרישות חוק (למשל חשבונאות, צוו שיפוטי).",
          ],
        },
        {
          h: "שמירה והעברה בין מדינות",
          p: [
            "שרתים וספקי ענן עשויים להימצא מחוץ למדינת מגוריכם. המשך שימוש בשירות מהווה הודאה בידיעה שכך עשוי להיות. ככל שהדין החל מחייב (למשל באיחוד האירופי), על מפעיל השירות להסדיר מול ספקים גם הסכמי עיבוד (DPA) — ויש להתאים את הנוסח לעורך־דין.",
          ],
        },
        {
          h: "הזכויות שלכם",
          p: [
            "בהתאם לדין החל, אתם עשויים להיות זכאים — בין השאר — לעיון, תיקון, מחיקה או הגבלת עיבוד בנוגע למידע עליכם. ניתן לפנות אלינו בכתובת: " + SUPPORT_EMAIL + ".",
          ],
        },
        {
          h: "שינויים",
          p: ["נעדכן את המדיניות מעת לעת. המשך שימוש לאחר עדכון עשוי להיחשב כהסכמה, לפי הדין החל."],
        },
      ],
    },
    en: {
      title: "Privacy Policy",
      updated: "Last updated: March 2026 (draft)",
      attorney:
        "This is a technical template. Before commercial launch or processing EU/US personal data, have counsel review and align with your actual data practices.",
      sections: [
        {
          h: "Who we are",
          p: [
            "InnerVoice / Temple of Light (the “Service”) is offered via the website and app. Privacy questions: " + SUPPORT_EMAIL + ".",
          ],
        },
        {
          h: "Information we may collect",
          p: [
            "Account details (e.g. email) when you register or sign in.",
            "Content you save in journeys (e.g. journal entries, questionnaire responses), depending on how you use the Service.",
            "Technical usage data (logs, IP address, device/browser type) for security and operations.",
            "If server-side text-to-speech is used, text sent for audio synthesis may be processed by a third-party provider (e.g. ElevenLabs) per server configuration. Browser/device speech may not use our servers.",
          ],
        },
        {
          h: "Purposes and legal bases",
          p: [
            "Providing the Service, authentication, support, quality improvement, and security.",
            "Where applicable, legal compliance (e.g. accounting, lawful requests).",
          ],
        },
        {
          h: "Retention and international transfers",
          p: [
            "Data may be processed on servers outside your country. Use of the Service acknowledges this. Use appropriate DPAs for GDPR where required.",
          ],
        },
        {
          h: "Your rights",
          p: [
            "Depending on applicable law, you may have rights to access, rectify, delete, or restrict processing — contact " + SUPPORT_EMAIL + ".",
          ],
        },
        {
          h: "Changes",
          p: ["We may update this policy. Continued use after updates may constitute acceptance under applicable law."],
        },
      ],
    },
    es: {
      title: "Politica de privacidad",
      updated: "Ultima actualizacion: marzo 2026 (borrador)",
      attorney:
        "Esta es una plantilla tecnica. Antes de un lanzamiento comercial o tratamiento de datos en la UE/EE.UU., revisela con un abogado.",
      sections: [
        {
          h: "Quienes somos",
          p: [
            "InnerVoice / Temple of Light (el “Servicio”) se ofrece por web y app. Contacto de privacidad: " + SUPPORT_EMAIL + ".",
          ],
        },
        {
          h: "Datos que podemos recopilar",
          p: [
            "Datos de cuenta (p. ej. correo) al registrarte o iniciar sesion.",
            "Contenido que guardas en los viajes, segun tu uso.",
            "Datos tecnicos (registros, IP, dispositivo/navegador) para seguridad y operacion.",
            "Si se usa voz en servidor, el texto puede procesarse con un proveedor externo (p. ej. ElevenLabs). La voz local del navegador puede no pasar por nuestros servidores.",
          ],
        },
        {
          h: "Fines",
          p: [
            "Prestar el servicio, autenticacion, soporte, mejora y seguridad.",
            "Cumplimiento legal cuando corresponda.",
          ],
        },
        {
          h: "Transferencias",
          p: [
            "Los datos pueden procesarse fuera de tu pais. El uso del servicio implica conocimiento de ello.",
          ],
        },
        {
          h: "Derechos",
          p: [
            "Segun la ley aplicable, puedes tener derechos de acceso, rectificacion, supresion u oposicion — escribe a " + SUPPORT_EMAIL + ".",
          ],
        },
        {
          h: "Cambios",
          p: ["Podemos actualizar esta politica. El uso continuado puede implicar aceptacion segun la ley."],
        },
      ],
    },
  },
  terms: {
    he: {
      title: "תנאי שימוש",
      updated: "עודכן לאחרונה: מרץ 2026 (טיוטה)",
      attorney: "תבנית טכנית — חובה לעבור עורך דין לפני השקה מסחרית.",
      sections: [
        {
          h: "מה השירות",
          p: [
            "השירות הוא מרחב דיגיטלי לתשומת לב פנימית ותוכן מונחה. הוא אינו טיפול רפואי, נפשי או משפטי ואינו תחליף לאיש מקצוע.",
          ],
        },
        {
          h: "זכאות",
          p: ["עליכם להיות בגיל החוקי לפי הדין במקום מגוריכם. אם אינכם עומדים בדרישת הגיל — אינכם רשאים להשתמש בשירות."],
        },
        {
          h: "שימוש מותר",
          p: [
            "להשתמש בשירות לצרכים אישיים לגיטימיים; לא להפר זכויות צד שלישי; לא לנסות לפרוץ או להעמיס על המערכת; לא להעביר תוכן פוגעני או בלתי חוקי.",
          ],
        },
        {
          h: "חשבון ואבטחה",
          p: ["אחריותכם לשמור על סודיות האמצעים לכניסה (למשל סיסמה) ועל כל פעילות המתבצעת בחשבונכם."],
        },
        {
          h: "קניין רוחני",
          p: ["התוכן, העיצוב והמותג שייכים למפעילי השירות אלא אם צוין אחרת."],
        },
        {
          h: "הגבלת אחריות",
          p: [
            "השירות ניתן “כמות שהוא”. איננו מתחייבים לתוצאה רגשית או טיפולית. במידה המרבית המותרת בדין — אחריות מוגבלת.",
          ],
        },
        {
          h: "שינויים והפסקה",
          p: ["נוכל לעדכן תנאים או להפסיק שירותים — לפי דין ולפי הצורך התפעולי."],
        },
        {
          h: "יצירת קשר",
          p: [SUPPORT_EMAIL],
        },
      ],
    },
    en: {
      title: "Terms of Service",
      updated: "Last updated: March 2026 (draft)",
      attorney: "Technical template — have counsel review before commercial launch.",
      sections: [
        {
          h: "What the Service is",
          p: [
            "The Service offers guided digital experiences for inner attention. It is not medical, mental-health, or legal advice and is not a substitute for a qualified professional.",
          ],
        },
        {
          h: "Eligibility",
          p: ["You must meet the minimum age required in your jurisdiction. If you do not, do not use the Service."],
        },
        {
          h: "Acceptable use",
          p: [
            "Use the Service for lawful personal purposes; do not infringe others’ rights; do not attempt to break security or overload systems; do not submit unlawful or abusive content.",
          ],
        },
        {
          h: "Account security",
          p: ["You are responsible for safeguarding credentials and activity on your account."],
        },
        {
          h: "Intellectual property",
          p: ["Content, branding, and design are owned by the operators unless stated otherwise."],
        },
        {
          h: "Disclaimer of warranties; limitation of liability",
          p: [
            "The Service is provided “as is.” We do not guarantee any emotional or therapeutic outcome. To the fullest extent permitted by law, liability is limited.",
          ],
        },
        {
          h: "Changes and termination",
          p: ["We may update these terms or discontinue features as permitted by law and operational needs."],
        },
        {
          h: "Contact",
          p: [SUPPORT_EMAIL],
        },
      ],
    },
    es: {
      title: "Terminos de uso",
      updated: "Ultima actualizacion: marzo 2026 (borrador)",
      attorney: "Plantilla tecnica — revision legal antes del lanzamiento comercial.",
      sections: [
        {
          h: "Que es el servicio",
          p: [
            "El Servicio ofrece experiencias digitales guiadas para la atencion interior. No es consejo medico, de salud mental ni legal ni sustituye a un profesional.",
          ],
        },
        {
          h: "Elegibilidad",
          p: ["Debes cumplir la edad minima legal en tu jurisdiccion."],
        },
        {
          h: "Uso aceptable",
          p: [
            "Uso personal y licito; no vulnerar derechos de terceros; no atacar la seguridad ni sobrecargar sistemas; no enviar contenido ilicito o abusivo.",
          ],
        },
        {
          h: "Cuenta",
          p: ["Eres responsable de tus credenciales y actividad."],
        },
        {
          h: "Propiedad intelectual",
          p: ["Contenido y marca pertenecen a los operadores salvo indicacion contraria."],
        },
        {
          h: "Limitacion de responsabilidad",
          p: [
            "El servicio se ofrece “tal cual”. No garantizamos resultados emocionales o terapeuticos. Responsabilidad limitada en la medida permitida por la ley.",
          ],
        },
        {
          h: "Cambios",
          p: ["Podemos actualizar terminos o discontinuar funciones."],
        },
        {
          h: "Contacto",
          p: [SUPPORT_EMAIL],
        },
      ],
    },
  },
};
